import { useState } from 'react'
import { List, Datagrid, FunctionField, downloadCSV, TextField as RATextField, Pagination } from 'react-admin'
import jsonExport from 'jsonexport/dist'
import { makeStyles } from '@material-ui/core/styles'
import DateRangeSelector from './components/DateRangeSelector'
import ExpandableMessagePanel from './components/ExpandableMessagePanel'
import LogsSearchFilter from './components/SearchFilter'
import DataExpandablePanel from './components/DataExpandablePanel'

const useStyles = makeStyles((theme) => ({
  timeframeContainer: { display: 'flex', alignItems: 'center', margin: theme.spacing(2) },
  listContainer: { padding: theme.spacing(2) },
  rowNumberCell: { width: 50, fontWeight: 'bold', textAlign: 'center' },
}))

const exporter = (logs) => {
  jsonExport(
    logs,
    { headers: ['id', 'timestamp', 'date', 'severity', 'errorCode', 'source', 'process', 'message'] },
    (err, csv) => downloadCSV(csv, 'modality-logs')
  )
}

const formatDate = (timestamp) => (timestamp ? new Date(timestamp).toISOString().replace('Z', '') : '')

const LogsList = (props) => {
  const classes = useStyles()
  const [timeframeFilter, setTimeframeFilter] = useState({ date_gte: undefined, date_lte: undefined })

  const handleTimeframeChange = (startTime, endTime) => {
    setTimeframeFilter({
      ...(startTime?.startsWith('-') ? { startTime } : startTime ? { date_gte: startTime } : {}),
      ...(endTime && { date_lte: endTime }),
    })
  }

  return (
    <div className={classes.listContainer}>
      <DateRangeSelector onChange={handleTimeframeChange} />
      <List
        {...props}
        title=' '
        filters={<LogsSearchFilter />}
        exporter={exporter}
        bulkActionButtons={false}
        filter={{ ...props.filter, ...timeframeFilter }}
        hasCreate={false}
        hasEdit={false}
        hasList={false}
        hasShow={false}
        sort={{ field: 'timestamp', order: 'DESC' }}
        pagination={<Pagination rowsPerPageOptions={[100, 1000, 5000]} />}
      >
        <Datagrid size='small' rowClick={false} expand={<DataExpandablePanel />}>
          <FunctionField label='#' render={(record) => <span className={classes.rowNumberCell}>{record.id}</span>} />
          <FunctionField label='Timestamp' render={(record) => formatDate(record.timestamp)} sortBy='timestamp' />
          <RATextField source='severity' />
          <RATextField source='source' />
          <RATextField source='errorCode' />
          <FunctionField label='Message' render={(record) => <ExpandableMessagePanel record={record} />} />
        </Datagrid>
      </List>
    </div>
  )
}

export default LogsList
